import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import _ from 'lodash';
import classes from './patient.module.scss';
import Button from '../../../_common/Form/Buttons/Button';
import { getOnePatient } from '../../../../store/actions/patients';
import accountHelpers from '../../../../utils/accountHelpers';
import Loader from '../../../_common/Loader/Loader';
import Prescriptions from './Tabs/Prescriptions';
import MedicalInsurance from './Tabs/MedicalInsurance';
import FilesDocs from './Tabs/FilesDocs';
import InfoNodes from './Tabs/InfoNodes';
import Tabs from '../../../_common/Tabs/Tabs';
import User from './Tabs/User';

const tabs = [
  {
    name: 'Prescriptions',
    content: <Prescriptions />,
  },
  {
    name: 'Medical insurance',
    content: <MedicalInsurance />,
  },
  {
    name: 'Files/Docs',
    content: <FilesDocs />,
  },
  {
    name: 'More Info/Notes',
    content: <InfoNodes />,
  },
  {
    name: 'User',
    content: <User />,
  },
];

const viewData = [
  {
    name: 'Name',
    path: 'name',
  },
  {
    name: 'Patient ID',
    path: 'id',
  },
  {
    name: 'Date of Birth',
    path: 'dob',
  },
  {
    name: 'Sex',
    path: 'sex',
  },
  {
    name: 'Patient Since',
    path: 'createdAt',
  },
  {
    name: 'Hub',
    path: 'hub',
  },
  {
    name: 'Location',
    path: 'location',
  },
];

function Patient() {
  const isPatient = accountHelpers.isInOneOfRoles(['Patient']);

  const dispatch = useDispatch();
  const { patient } = useSelector((store) => store.patients);
  const { patientId } = useParams();
  const [loading, setLoading] = useState(true);
  const [currentTab, setCurrentTab] = useState('Prescriptions');

  const {
    firstName, lastName, id, dob, sex, createdAt,
    hub, phone, phone2, phone3, addressStreet,
    addressCity, addressState, addressZipCode,
    address2Street, address2City, address2State,
    address2ZipCode, address3Street, address3City,
    address3State, address3ZipCode, email, location,
  } = patient;

  const address = _.compact([addressStreet, addressCity, addressState, addressZipCode]);
  const address2 = _.compact([address2Street, address2City, address2State, address2ZipCode]);
  const address3 = _.compact([address3Street, address3City, address3State, address3ZipCode]);

  useEffect(() => {
    (async () => {
      await dispatch(getOnePatient({ patientId, userId: accountHelpers.getUser().id }));

      setLoading(false);
    })();
  }, []);

  return (
    <>
      {loading
        ? (
          <Loader className={classes.loader} />
        )

        : (
          <div className={classes.patient_wrapper}>
            <div className={classes.header_wrapper}>
              <div>
                <h2>{`${firstName} ${lastName}`}</h2>

                <div className={classes.viewData}>
                  <ul>
                    {viewData.map((v) => (
                      <li key={v.name}>
                        {v.name}
                      </li>
                    ))}
                  </ul>

                  <ul>
                    <li>{`${firstName} ${lastName}`}</li>

                    <li>{`#${id}`}</li>

                    <li>{moment(dob).isValid() ? moment(dob).format('MM/DD/YYYY') : '-'}</li>

                    <li>{sex || '-'}</li>

                    <li>{moment(createdAt).isValid() ? moment(createdAt).format('MM/DD/YYYY') : '-'}</li>

                    <li>{hub || '-'}</li>

                    <li>{location}</li>
                  </ul>

                  <ul>
                    {phone && <li>{phone}</li>}

                    {phone2 && <li>{phone2}</li>}

                    {phone3 && <li>{phone3}</li>}

                    {(!_.isEmpty(address)) && <li>{address.join(', ')}</li>}

                    {(!_.isEmpty(address2)) && <li>{address2.join(', ')}</li>}

                    {(!_.isEmpty(address3)) && <li>{address3.join(', ')}</li>}

                    {email && <li>{email}</li>}
                  </ul>

                </div>
              </div>

              {!isPatient && (
              <div className={classes.button_wrapper}>
                {currentTab === 'Prescriptions' && (
                <Button
                  className={classes.button}
                  title="Print"
                  type="button"
                  printButton
                  onClick={() => window.print()}
                />
                )}

                <Button
                  className={classes.button}
                  editButton
                  title="Edit patient"
                  type="button"
                  href={`/patients/${patientId}/edit`}
                />

                <Button
                  className={classes.add_btn}
                  title="Add a new script"
                  type="button"
                  href={`/scripts/add/${patientId}`}
                  reverseColor
                  addButton
                />
              </div>
              )}
            </div>

            <Tabs
              tabs={isPatient
                ? tabs.filter((t) => t.name !== 'Files/Docs' && t.name !== 'Medical insurance')
                : tabs}
              setCurrentTab={setCurrentTab}
              currentTab={currentTab}
              defaultLinePosition={{ left: '0px', right: '476.975px' }}
            />
          </div>
        )}
    </>
  );
}

export default Patient;
